export const commonImages = {
  delete_icon: 'assets/img/menuIcon/delete_icon.svg',
  location_pin: 'assets/img/location.svg',
  plus: 'assets/img/plus-solid.svg',
  camera: 'assets/img/sp-img/camera.svg',
  upload_file: 'assets/img/camera_up.svg',
  edit_icon: 'assets/img/pencil.svg',
  library_edit_icon: 'assets/img/edit.svg',
  automation_icon: 'assets/img/process.svg',
  close_icon: 'assets/img/bed-bath/Close_square_light.svg',
  mobile_filter: 'assets/img/mob_filter.svg',
  table_filter: 'assets/img/filter-task.svg',
  calendar: 'assets/img/calendar.svg',
  notes: 'assets/img/note.svg',
  list_view: 'assets/img/list.svg',
  uploading_logo: 'assets/img/bed-bath/upload-logo.svg',
  calendar_icon_v2: 'assets/img/dashboadIcon/calendar-v2.svg',
  grid_view: 'assets/img/u_grids.svg',
  eye_icon: 'assets/img/editor/eye-view.png',
  image_not_found: 'assets/img/images-not-found.svg',
  lead_icon: 'assets/img/dashboadIcon/lead.svg',
  open_container: 'assets/img/kpi/open_container.svg',
  calendar_icon: 'assets/img/dash/svg/calander.svg',
  enquiry: 'assets/img/graphics/Enquiry.svg',
  contact_calendar: 'assets/img/graphics/calender.svg',
  email_overview_icon: 'assets/img/lead-overview/time@2x.png',
  email_user_icon: 'assets/img/lead-overview/users@2x.png',
  contact_lead_icon: 'assets/img/lead-overview/activity-dark@2x.png',
  loading_state_gif: 'assets/new-img/Loading-State.gif',
  loading_gif: 'assets/new-img/loading.gif',
  email_icon: 'assets/img/graphics/Email.svg',
  pencil_icon: 'assets/img/bed-bath/cil-pencil.svg',
  stop_icon: 'assets/img/pricing-icon/stop-recording.svg',
  email_call_icon: 'assets/img/lead-overview/call@2x.png',
  grid_view_v2: 'assets/img/grid.svg',
  lock_icon: 'assets/img/menuIcon/lock.svg',
  linear_map: 'assets/img/menuIcon/map-linear.svg',
  filter_icon: 'assets/img/menuIcon/filter_icon.svg',
  group_icon: 'assets/img/Group37073.svg',
  carrot_icon: 'assets/img/drawing-icons/carrot.svg',
  no_logo_icon: 'assets/img/bed-bath/no-logo.svg',
  upload_logo: 'assets/img/bed-bath/upload-logo.svg',
  pin_icon: 'assets/img/dashboadIcon/pin.svg',
  pin_filled_icon: 'assets/img/dashboadIcon/pin-fill.svg',
  user_business_icon: 'assets/img/Peoples_user-business.svg',
  search_filter_icon: 'assets/img/Filter.svg',
  bed_icon: 'assets/img/bed-bath/Bed.svg',
  bath_icon: 'assets/img/bed-bath/Bath.svg',
  car_icon: 'assets/img/bed-bath/Car.svg',
  area_svg: 'assets/img/area-1.svg',
  pool_icon: 'assets/img/bed-bath/pool.svg',
  home_icon: 'assets/img/1-home-2.svg',
  stream_icon: 'assets/img/stream-icon.svg',
  tag_one_icon: 'assets/img/pricing-icon/tag-one.svg',
  single_bed_icon: 'assets/img/pricing-icon/Life_single-bed.svg',
  cil_bathroom_icon: 'assets/img/pricing-icon/cil-bathroom.svg',
  garage_icon: 'assets/img/pricing-icon/cil-garage.svg',
  area_icon: 'assets/img/pricing-icon/area 1.svg',
  house_plan_icon: 'assets/img/pricing-icon/house-plan 1.svg',
  location_icon: 'assets/img/dashboadIcon/location.svg',
  delete_theme: 'assets/img/delete-themes.svg',
  home: 'assets/img/home.svg',
  project_1: 'assets/img/dashboadIcon/project1.svg',
  sm_edit_icon: 'assets/new-img/icons/ic-sm-edit.svg',
  area_1_icon: 'assets/img/pricing-icon/area 1.svg',
  light_img_icon: 'assets/img/Iconly_Light_Image.svg',
  gavel_icon: 'assets/img/gavel.svg',
  conjunction_icon: 'assets/img/conjunctions.svg',
  stream_new: 'assets/img/graphics/streamNew.svg',
  email_building_icon: 'assets/img/lead-overview/building@2x.png',
  user_profile_icon: 'assets/new-img/user-profile.png',
  profile_image: 'assets/img/profile-md.jpg',
  accessible_icon: 'assets/img/menuIcon/accessible.svg',
  project_1_icon: 'assets/img/menuIcon/project1.svg',
  contract_delete: 'assets/img/pricing-icon/ins-del.svg',
  record_icon: 'assets/img/pricing-icon/record-icon.svg',
  face_image: 'assets/new-img/profile.png',
  listing_icon: 'assets/img/dashboadIcon/listing.svg',
  phoneBook_icon: 'assets/img/dashboadIcon/phoneBook.svg',
  contract_icon: 'assets/img/dashboadIcon/contract.svg',
  apartment_icon: 'assets/img/dashboadIcon/apartment.svg',
  task_icon: 'assets/img/dashboadIcon/task.svg',
  cloud_icon: 'assets/img/dashboadIcon/cloud.svg',
  voice_icon: 'assets/img/voice1.svg',
  loader_gif: 'assets/new-img/loader.gif',
  right_user_icon: 'assets/img/Peoples_right-user.svg',
  user_icon: 'assets/img/menuIcon/user.svg',
  user_group_icon: 'assets/img/menuIcon/user_group.svg',
  home_sidebar_icon: 'assets/img/dashboadIcon/home.svg',
  marketplace_icon: 'assets/img/dashboadIcon/marketPlace.svg',
  report_icon: 'assets/img/dashboadIcon/report.svg',
  folder_icon: 'assets/img/dashboadIcon/folder.svg',
  history_icon: 'assets/img/dashboadIcon/history.svg',
  settings_icon: 'assets/img/dashboadIcon/setting.svg',
  pinned_icon: 'assets/img/dashboadIcon/pinned.svg',
  dots_icon: 'assets/img/dashboadIcon/dots.svg',
  view_icon: 'assets/img/Icon-Button-n-bg.svg',
  loader_icon: 'assets/svg/matrix/loader.svg',
  calendar_time: 'assets/img/calendar-time.svg',
  elips_icon: 'assets/img/kpi/elips.svg',
  kpi_meter_icon: 'assets/img/kpi/kpimeter.svg',
  confetti_gif: 'assets/img/kpi/confetti.gif',
  pause_icon: 'assets/img/automation-icons/pause.svg',
  play_icon: 'assets/img/automation-icons/Play.svg',
  upload_icon: 'assets/img/folder-open.svg',
  eoi_icon: 'assets/img/cloud-plus.svg',
  price_list_close_icon: 'assets/img/price-list-close.svg',
  save_close: 'assets/img/save-close.svg',
};
